import { Injectable, Injector } from '@angular/core';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IGetBusinessResponse } from '../models';

@Injectable()
export class BusinessService extends BaseApiService {
  /**
   * Creates an instance of BusinessFinder Service.
   * @param injector require for BaseApiService
   */
  constructor(protected injector: Injector) {
    super(injector);
  }

  getBusinessName(businessId: string): Observable<IGetBusinessResponse> {
    const endpoint = `${environment.business.default.baseUrl}/business/${businessId}/name`;
    return this.httpAuthGet<IGetBusinessResponse>(endpoint);
  }
}
